(() => {
  try {
    const KEY = "purchase_origin";
    const url = new URL(window.location.href);

    // Si viene por query param, lo guardamos
    const origin = url.searchParams.get("origin");
    const current = sessionStorage.getItem(KEY);
    if (origin) {
      if (origin === "fecosur" && current && current.includes("cooperativa")) {
        return;
      }
      sessionStorage.setItem(KEY, origin);
      return;
    }

    // Fallback referrer
    const ref = document.referrer || "";

    if (ref.includes("/collections/fecosur")) {
      sessionStorage.setItem(KEY, "fecosur");
    }

    const match = ref.match(/\/collections\/([^/?#]+)/);

    if (match && match[1].includes("cooperativa")) {
      sessionStorage.setItem(KEY, match[1]);
    }
  } catch (e) {
    // no-op
  }
})();
